// extracted by mini-css-extract-plugin
module.exports = {"body":"StableBlock_body__1SP2T"};